function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "2A41F9D9-8CE0-426D-ABC5-EEF97487C589@1x");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-896.000000, -704.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "commentary",
  transform: "translate(912.000000, 720.000000) rotate(-360.000000) translate(-912.000000, -720.000000) translate(896.000000, 704.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "box",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("g", {
  id: "symbol",
  fill: "#1E445C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27,4 C27.5522847,4 28,4.44771525 28,5 L28,20 C28,20.5522847 27.5522847,21 27,21 L13.5635235,21 C13.3452706,21 13.1330103,21.0714028 12.9591311,21.2033132 L5.60439238,26.782856 C5.16439442,27.1166527 4.5371099,27.0305596 4.20331321,26.5905616 C4.07140283,26.4166824 4,26.2044221 4,25.9861692 L4,5 C4,4.44771525 4.44771525,4 5,4 L27,4 Z M26,6 L6,6 L6,23.971 L11.7503463,19.6099396 C12.2140242,19.2581786 12.7686795,19.0498429 13.3460697,19.0078888 L13.5635235,19 L26,19 L26,6 Z M22,13 C22.5522847,13 23,13.4477153 23,14 C23,14.5522847 22.5522847,15 22,15 L10,15 C9.44771525,15 9,14.5522847 9,14 C9,13.4477153 9.44771525,13 10,13 L22,13 Z M22,9 C22.5522847,9 23,9.44771525 23,10 C23,10.5522847 22.5522847,11 22,11 L10,11 C9.44771525,11 9,10.5522847 9,10 C9,9.44771525 9.44771525,9 10,9 L22,9 Z"
})))));

var SvgCommentary = function SvgCommentary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommentary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/commentary.a7304fcf.svg";
export { ForwardRef as ReactComponent };